export const state = {
  notification: null
};

export const getters = {
  hasNotification: state => state.notification != null
};

export const mutations = {
  SET_NOTIFICATION(state, notification) {
    state.notification = notification;
  }
};

export const actions = {
  setNotification({ commit }, [notification, callingMethod]) {
    if (typeof notification === "string" || notification instanceof String)
      commit("SET_NOTIFICATION", notification);
    // assum its an error object
    else {
      var errorMsg = "";
      if (notification.response) {
        errorMsg =
          `Error in ${callingMethod}: ` +
          notification.response.status +
          "." +
          notification.response.data.error.code +
          " " +
          notification.response.data.error.message;
      } else if (notification.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        errorMsg = notification.request;
      } else {
        // Something happened in setting up the request that triggered an Error
        errorMsg = "Error" + notification.message;
      }

      commit("SET_NOTIFICATION", errorMsg);
    }
  },
  clearNotification({ commit }) {
    commit("SET_NOTIFICATION", null);
  }
};
